export default "__VITE_ASSET__DWJN5nMR__"